import DB from '../data/mockData';

function dotColor(dot) {
  if (dot === 'add') return 'var(--green)';
  if (dot === 'rem') return 'var(--red)';
  return 'var(--teal)';
}

export default function ListHistory() {
  return (
    <div className="content">
      <div className="row g-3">
        {/* Change log */}
        <div className="col-lg-7">
          <div className="card">
            <div className="ch">
              <div className="ch-ico">📋</div>
              <div><div className="ch-title">Product List Change Log</div><div className="ch-sub">Nova detects additions, removals and status changes</div></div>
              <div className="ch-act ms-auto"><span className="ai-badge">✦ Auto-parsed</span></div>
            </div>
            <div className="cb">
              <div className="p-2 px-3 rounded-2 mb-3" style={{ background: 'var(--amber2)', fontSize: '11.5px', color: 'var(--amber)' }}>
                ⚠ Automatic version diff activating Phase 1b — manual comparison available now via Nova.
              </div>
              {DB.history.map((h, i) => (
                <div key={i} className="d-flex gap-3 py-2 align-items-start" style={{ borderBottom: i < DB.history.length - 1 ? '1px solid var(--brd2)' : 'none' }}>
                  <div style={{ width: 8, height: 8, borderRadius: '50%', marginTop: 4, flexShrink: 0, background: dotColor(h.dot) }} />
                  <div style={{ fontFamily: "'DM Mono',monospace", fontSize: 10, color: 'var(--t3)', width: 58, flexShrink: 0, paddingTop: 1 }}>{h.date}</div>
                  <div className="flex-grow-1">
                    <div style={{ fontSize: '12.5px', fontWeight: 600 }}>{h.title}</div>
                    <div style={{ fontSize: '11.5px', color: 'var(--t2)' }}>{h.desc}</div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Recent uploads */}
        <div className="col-lg-5">
          <div className="card">
            <div className="ch"><div className="ch-ico">⬆</div><div><div className="ch-title">Recent Uploads</div></div></div>
            <div className="cb d-flex flex-column gap-2">
              {DB.uploads.map((u, i) => (
                <div key={i} className="d-flex align-items-center gap-2 p-2 rounded-2" style={{ background: 'var(--surf)', cursor: 'pointer' }}>
                  <span style={{ fontSize: 18 }}>📄</span>
                  <div className="flex-grow-1">
                    <div style={{ fontSize: 12, fontWeight: 600 }}>{u.file}</div>
                    <div style={{ fontSize: 11, color: 'var(--t3)' }}>{u.date} · {u.products} products</div>
                  </div>
                  <span className={`pill ${u.status === 'Validated' ? 'p-g' : 'p-a'}`}>{u.status === 'Validated' ? '✓ ' : ''}{u.status}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
